import { Page } from '@/domains';
import { authorizedApi } from '../network/authorized-api';

export const getTransactions = (userId: string, page: number, pageSize: number): Promise<Page<Transaction>> =>
  authorizedApi.get('/admin/transactions', { userId, pageNumber: page, pageSize: pageSize });
